import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import styled from 'styled-components';
import { Button, Link } from '@telia/styleguide';
import AdditionalProduct from '../../modules/additional-product/AdditionalProduct';
import { AdditionalProductActions, SetAdditionalProduct } from '../../store/actions';
import { useStore } from '../../store/store';
import { Product, SalesPackage } from '../../types';
import { pushAddToCart, pushPageview, pushProductClick, pushProductImpression } from '../../util/GoogleTagManager';
import { metaData } from '../../util/Metadata';
import { routes } from '../../util/utils';
import { MediaQueries } from '../../util/MediaQueries';

const AdditionalProducts: React.FC<RouteComponentProps> = props => {
  const { dispatch, state } = useStore();
  const salesPackage: SalesPackage = state.packages.selectedPackage!;

  useEffect(() => {
    if (!salesPackage) {
      pushPageview(routes.address);
      return props.history.push(routes.address);
    }
    if (salesPackage && salesPackage.additionalProducts.length === 0) {
      pushPageview(routes.personalia);
      return props.history.push(routes.personalia);
    } else if (salesPackage && salesPackage.additionalProducts.length !== 0) {
      return pushProductImpression(salesPackage.additionalProducts);
    }
  }, []);

  const selectProduct = (product: Product) => {
    if (
      state.packages.selectedAdditionalProducts.some(prod => prod.commercialProductId === product.commercialProductId)
    ) {
      dispatch({
        type: AdditionalProductActions.DESELECT_ADDITIONAL_PRODUCT,
        payload: product
      } as SetAdditionalProduct);
    } else {
      dispatch({ type: AdditionalProductActions.SELECT_ADDITIONAL_PRODUCT, payload: product } as SetAdditionalProduct);
      pushProductClick(product, 1);
    }
  };

  if (!salesPackage) {
    return null;
  }
  const { selectedAdditionalProducts } = state.packages;
  return (
    <Container>
      <Wrapper>
        <PackageContainer>
          {salesPackage.additionalProducts.map((additionalProduct, index) => {
            return (
              <AdditionalProduct
                key={index}
                product={additionalProduct}
                onSelect={() => selectProduct(additionalProduct)}
                description={metaData[additionalProduct.commercialProductId + ''].desc}
                selected={state.packages.selectedAdditionalProducts.some(
                  prod => prod.commercialProductId === additionalProduct.commercialProductId
                )}
              />
            );
          })}
        </PackageContainer>
        <ButtonContainer>
          <Link
            href={''}
            onClick={(e: React.MouseEvent<HTMLElement>) => {
              e.preventDefault();
              props.history.goBack();
            }}
            text="Tilbake"
            icon={'arrow-left'}
            iconPosition={'before'}
          />
          <HorizontalSpacer />
          <Button
            text="Fortsett"
            kind={'primary'}
            onClick={() => {
              if (selectedAdditionalProducts.length > 0) {
                pushAddToCart(selectedAdditionalProducts);
              }
              pushPageview(routes.personalia);
              props.history.push(routes.personalia);
            }}
          />
        </ButtonContainer>
      </Wrapper>
    </Container>
  );
};

export default AdditionalProducts;

const Container = styled.div`
  margin: 0 auto 1rem;
  padding: 0 3rem;
  text-align: left;
  max-width: 1350px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  ${MediaQueries.onlyMobile} {
    padding: 0;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 2rem;
`;

const PackageContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
`;

const ButtonContainer = styled.div`
  margin-top: 2rem;
  display: flex;
  align-items: center;
  align-self: flex-end;
`;

const HorizontalSpacer = styled.div`
  margin: 0 1rem;
`;
